import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBalanceStatement = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 32,
	viewBox: "0 0 30 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.57129 0H23.8713L29.9999 5.2V26H9.57129V0Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.0716 8.3573L16.0716 9.28587L24.4287 9.28587L24.4287 8.3573L16.0716 8.3573Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.0716 12.0718L16.0716 13.0003L24.4287 13.0003L24.4287 12.0718L16.0716 12.0718Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.0716 15.7854L16.0716 16.714L24.4287 16.714L24.4287 15.7854L16.0716 15.7854Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2143 21.9997L11.8214 21.9997V15.7854V15.0354H11.0714H7.14284H6.39284V15.7854V21.9997H4H2.38292L3.42746 23.2341L8.5346 29.2699L9.10714 29.9465L9.67968 29.2699L14.7868 23.2341L15.8314 21.9997L14.2143 21.9997Z",
			fill: "#FF3131",
			stroke: "white",
			strokeWidth: 1.5
		})
	]
});
export default SvgBalanceStatement;
